import $ from "jquery";
import { hidePageLoader, showPageLoader } from "./page-loader";
import { updateCart, getSectionsToRender } from "./catifa-cart";

const whiteGlovesShippingDataInputSelector =
  'input[name="white-gloves-shipping"]';
const cartItemSelector = ".cart-item";

export const manageCatifaShipping = async () => {
  manageWhiteGlovesShipping();
};

export const getWhiteGlovesShippingProductInCart = (): string | undefined => {
  const $whiteGlovesShippingDataInput = $(whiteGlovesShippingDataInputSelector);
  const whiteShippingProductId =
    $whiteGlovesShippingDataInput.data("productId");
  // Check if any cart item matches the white glove shipping product ID
  if (
    $(cartItemSelector)
      .toArray()
      .some((cartItem) => {
        const quantityVariantId = $(cartItem)
          .find("input.quantity__input")
          .data("quantityVariantId");
        return quantityVariantId === whiteShippingProductId;
      })
  ) {
    return whiteShippingProductId.toString();
  }
  return;
};

export const updateWhiteGlovesQty = async (
  resp: Response,
  id: string,
  line: string,
  name: string | undefined,
) => {
  const parsedState = await resp.json();
  const footerSections = getSectionsToRender().filter(
    (section) => section?.id === "main-cart-footer",
  );
  if (footerSections.length > 0) {
    const footerSection = footerSections[0];
    if (footerSection && footerSection.section) {
      const qty =
        (
          new DOMParser()
            .parseFromString(
              parsedState.sections[footerSection.section],
              "text/html",
            )
            ?.querySelector(
              footerSection.selector +
                " " +
                whiteGlovesShippingDataInputSelector,
            ) as HTMLElement
        )?.dataset.quantity ?? 0;
      const response = await fetch(
        // next api call will not affect the cart and will not return any error if the id of the product passed is not in cart.
        // so id param can be retrieved by a function like getWhiteGlovesShippingProductInCart that will not really check the presence of the item in cart calling /cart.js API
        window.Shopify.routes.root + "cart/change.js",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: id,
            quantity: qty,
            sections: getSectionsToRender().map((section) => section?.section),
            sections_url: window.location.pathname,
          }),
        },
      );

      await updateCart(response, line, name);
    }
  }
};

const manageWhiteGlovesShipping = async () => {
  document.addEventListener(
    "catifa-white-gloves-shipping-added",
    async function (event: Event) {
      if (!event.target) {
        return;
      }
      showPageLoader();
      try {
        const $target = $(event.target);
        const whiteGlovesProductId = $target.data("productId").toString();
        const quantity = Number($target.data("quantity"));
        const response = await fetch(
          window.Shopify.routes.root + "cart/add.js",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              items: [
                {
                  id: Number(whiteGlovesProductId),
                  quantity: quantity,
                },
              ],
              sections: getSectionsToRender().map(
                (section) => section?.section,
              ),
              sections_url: window.location.pathname,
            }),
          },
        );
        await updateCart(response, "", "");
      } catch (e) {
        console.error(e);
      } finally {
        hidePageLoader();
      }
    },
  );

  document.addEventListener(
    "catifa-white-gloves-shipping-removed",
    async function (event: Event) {
      if (!event.target) {
        return;
      }
      showPageLoader();
      try {
        const $target = $(event.target);
        const whiteGlovesProductId = $target.data("productId").toString();
        const response = await fetch(
          window.Shopify.routes.root + "cart/change.js",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              id: whiteGlovesProductId,
              quantity: 0,
              sections: getSectionsToRender().map(
                (section) => section?.section,
              ),
              sections_url: window.location.pathname,
            }),
          },
        );
        await updateCart(response, "", "");
      } catch (e) {
        console.error(e);
      } finally {
        hidePageLoader();
      }
    },
  );
};

document.addEventListener("DOMContentLoaded", async function () {
  if (document.body.classList.contains("template-cart")) {
    // fix white gloves items in cart on each cart page load
    // white gloves items should not be the right number if a new chair is added to cart from product page
    showPageLoader();
    try {
      const $whiteGlovesShippingDataInput = $(
        whiteGlovesShippingDataInputSelector,
      );
      const whiteGlovesShippingProductId =
        $whiteGlovesShippingDataInput.data("productId");
      const whiteGlovesShippingExpectedQty = Number(
        $whiteGlovesShippingDataInput.data("quantity"),
      );
      if (!whiteGlovesShippingProductId || !whiteGlovesShippingExpectedQty) {
        return;
      }
      let isWhiteGlovesShippingActive = false;
      let whiteGlovesShippingProductQty: number = 0;
      const $cartItems = $(cartItemSelector) as JQuery<HTMLInputElement>;
      $cartItems.each(function () {
        const whiteGlovesShippingProductQtyInout = $(this).find(
          "input.quantity__input",
        );
        if (
          whiteGlovesShippingProductQtyInout.data("quantityVariantId") ===
          whiteGlovesShippingProductId
        ) {
          isWhiteGlovesShippingActive = true;
          whiteGlovesShippingProductQty = Number(
            whiteGlovesShippingProductQtyInout.val()?.toString(),
          );
          return false; // breaks
        }
        return; // continue
      });
      if (
        !isWhiteGlovesShippingActive ||
        whiteGlovesShippingExpectedQty === whiteGlovesShippingProductQty
      ) {
        return;
      }
      const response = await fetch(
        window.Shopify.routes.root + "cart/change.js",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: whiteGlovesShippingProductId.toString(),
            quantity: whiteGlovesShippingExpectedQty,
            sections: getSectionsToRender().map((section) => section?.section),
            sections_url: window.location.pathname,
          }),
        },
      );
      await updateCart(response, "", "");
    } catch (e) {
      console.log(e);
    } finally {
      hidePageLoader();
    }
  }
});
